import { useQuery } from "react-query";
import EarningsPerPeriodPresenter from "./EarningsPerPeriodPresenter";
import { TotalMonth } from "./earnings-per-period.models";
import { DONATION_UPDATE_EVENT_NAME, MERCH_UPDATE_EVENT_NAME, PERFORMANCE_DETAILS_UPDATE_EVENT_NAME } from "../../features/earnings/constants";
import useEventListeners from "@arelia-hooks/useEventListeners";
import { ComponentProps } from "@arelia-types/widget";
import { http } from "src/api/http";

export default function EarningsPerMonthContainer({ config }: ComponentProps) {
  const { data = {
    thisMonth: 0,
    lastMonth: 0,
  }, isLoading, isError, refetch } = useQuery<TotalMonth>({
    queryKey: ["total-month"],
    queryFn: () => http(`/api/earnings/total-month${config.query ? `?${config.query}` : ''}`),
  });

  useEventListeners([
    DONATION_UPDATE_EVENT_NAME,
    MERCH_UPDATE_EVENT_NAME,
    PERFORMANCE_DETAILS_UPDATE_EVENT_NAME
  ], () => {
    refetch();
  });

  return (
    <EarningsPerPeriodPresenter
      earnings={data}
      loading={isLoading}
      error={isError}
      timespan="Month"
      widgetId="THIS_MONTH_EARNINGS"
    />
  );
}
